import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "50",
  height: "41",
  viewBox: "0 0 50 41",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#F1F1F1",
    d: "M47.666 37H2.333C1.083 37 0 35.908 0 34.648V8.352A2.338 2.338 0 012.333 6h45.333C49 6 50 7.092 50 8.352v26.296C50 35.908 48.916 37 47.666 37z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#4B4C4C",
    d: "M6 26.3h38V28H6v-1.7zm0-4.531h38v1.699H6v-1.7zM6 14h19.379v3.642H6V14z",
    opacity: ".34"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#000",
    d: "M29.205 36.112L21 41l.592-2.023 1.86-6.742L43.248 4 49 7.793",
    opacity: ".15"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#E07C46",
    d: "M43.084 0L49 3.306 29.666 35.71 22 41l1.833-8.68"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FFF",
    d: "M30 35.6L23.913 32 22 41",
    opacity: ".6"
  })]
});